import React, { Component } from 'react';
import SimpleMDE from 'simplemde';
import { Button, Input, Section } from 'bulma-react'
import { store } from '../services';

import 'simplemde/dist/simplemde.min.css';

export class Editor extends Component {
  constructor(props) {
    super(props);
    const { id } = props;
    this.state = {
      isLoading: !!id,
      id,
    };
    if (id) {
      store.main.findOne(id)
        .then(item => {
          this.setState({ isLoading: false, ...item });
          const content = item.hasDetail ? item.markDown : item.preview;
          this.simpleMde.value(content);
        })
        .catch(err => {
          this.setState({ isLoading: false, error: err });
        });
    }
  }
  componentDidMount = () => {
    const elm = this.refs.editor;
    this.simpleMde = new SimpleMDE({ element: elm, spellChecker: false });
  };
  onSubmit = (e) => {
    e.preventDefault();
    const { id, history } = this.props;
    const { title } = this.state;
    const markDown = this.simpleMde.value();
    const blog = {
      title,
      preview: markDown,
      creationTime: new Date().getTime(),
      updatedAt: new Date().getTime(),
      hasDetail: false,
    };
    if (markDown.length > 100) {
      blog.preview = markDown.substr(0, 100) + '...';
      blog.hasDetail = true;
      blog.markDown = markDown;
    }
    let promise;
    if (id) {
      promise = store.main.update(id, blog);
    } else {
      promise = store.main.insert(blog);
    }
    promise.then((res) => {
      history.goBack();
    });
  };
  render() {
    const { isLoading, title } = this.state;
    return (
      <Section editor>
        <h2>edit</h2>
        <form onSubmit={this.onSubmit}>
          <Input
            is-loading={isLoading}
            value={title}
            onChange={(e)=>this.setState({ title: e.target.value})}
            placeholder="title"/>
          <textarea ref="editor" disabled={isLoading}/>
          <Button type="submit" isLoading={isLoading}>Save</Button>
        </form>
      </Section>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/editor.js